/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react';
import cytoscape from 'cytoscape';
import { cytoscapeStyles } from '../styles';
import fcose from 'cytoscape-fcose';
import coseBilkent from 'cytoscape-cose-bilkent';
import cola from 'cytoscape-cola';
import { selectCyNodes } from '../utils/cyutils';
import { connectedNodes } from '../utils/cyutils';

cytoscape.use(fcose);
cytoscape.use(coseBilkent);
cytoscape.use(cola);


const Graph = ({ elements, selection, setSelection, mostrarOrg }) => {
  const cyContainerRef = useRef(null);
  const cyRef = useRef(null);

  useEffect(() => {
    if (!cyRef.current) {
      // Inicializar Cytoscape solo si aún no existe
      cyRef.current = cytoscape({
        container: cyContainerRef.current,
        style: cytoscapeStyles,
        elements
      })

      const cy = cyRef.current;
      setLayout(cy).run()

      // Evento al hacer clic en un nodo
      cy.on('tap', 'node', (event) => setSelection({
        selectedNodes: connectedNodes(event.target.data('id')),
        connections: true
      }))

      // cualquier tap fuera del gráfico lo vuelve a la normalidad (elimina la selección)
      cy.on('tap', (event) => {
        if (event.target === cy) {
          cy.elements().removeClass('dimmed');
        }
      })
    }
    
    if (selection) selectCyNodes(cyRef, selection)

    return () => {
      const cy = cyRef.current;

      // Limpiar la instancia si el componente se desmonta
      if (cy) {
        cy.destroy();
        cyRef.current = null;
      }
    };
  // eslint-disable-next-line
  }, [elements, setSelection])

  useEffect(() => selectCyNodes(cyRef, selection), [selection])

  useEffect(() => {
    const cy = cyRef.current;

    // Ocultar todos los nodos con clase .org
    if (!mostrarOrg)
      cy.nodes('.org').style('display', 'none');
    else {
      cy.nodes('.org').style('display', "element");
    }
  }, [elements, mostrarOrg]);

  const setLayout = (cy) => {
    return cy.layout({
      name: 'cose-bilkent',
      // Espaciado
      nodeRepulsion: 10000, // Fuerza de repulsión entre nodos
      idealEdgeLength: 50,  // Longitud ideal de las aristas
      edgeElasticity: 0.2,  // Elasticidad de las aristas
      // Estabilidad
      numIter: 2500,        // Número máximo de iteraciones
      tile: true,           // Agrupar nodos superpuestos antes de layout
      randomize: false,     // Mantiene consistencia en la disposición
      // Optimización
      gravity: 0.25,        // Atracción general hacia el centro
      gravityRangeCompound: 1.5, // Influencia de la gravedad en compuestos
      gravityCompound: 1.0, // Atracción entre nodos compuestos
    });
  }

  return <div className="graph" ref={cyContainerRef}></div>;
};

export default Graph;
